import React, { Fragment } from 'react';
import HomeView from './HomeView';

// Thin route entry — the V3 shell lives inside the view.
const TenantHome = () => (
    <Fragment>
        <HomeView />
    </Fragment>
);

export default TenantHome;
